/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
import * as React from 'react';
import Constants from '../libraries/Constants';
import { connect } from 'react-redux';
import RbButton, { ButtonSize, ButtonType } from '../../bosch-react/components/button/RbButton';
import RbSearchField from '../../bosch-react/components/search-field/RbSearchField';
import RbLabel from '../../bosch-react/components/label/RbLabel';
import { showDialog, showToastMessage } from '../../features/Dialog/actions';
import { RootState } from '../../store/store';
import { IUserProfile } from '../../features/Auth/types';
import { exportToExcel } from '../../services/excelServices';

interface ListActionsMenuProps {
    userProfile: IUserProfile | undefined,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
    showAdminResults: any,
    getAdminData: any,
    searchText: any,
    items: any[],
    columns: any[],
    disableAdminMode?: boolean,
    exportFileName?: string,
    refresh?: any,
}

class ListActionsMenu extends React.Component<ListActionsMenuProps, any> {

    constructor(props: ListActionsMenuProps) {
        super(props);
        this.exportToExcel = this.exportToExcel.bind(this);
    }

    render() {
        const { showAdminResults, refresh } = this.props
        let menu: any;
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {
            menu = <div className="right-menu-button">
                <RbButton type={ButtonType.Secondary} size={ButtonSize.Tiny} label="Export To Excel" style={{ minWidth: "3rem" }} onClick={this.exportToExcel} />
                {showAdminResults !== undefined && showAdminResults !== null &&
                    <RbButton
                        type={ButtonType.Secondary}
                        size={ButtonSize.Tiny}
                        label={(this.props.showAdminResults === false) ? 'Show Admin Mode' : 'Show User Mode'}
                        style={{ minWidth: "3rem" }} onClick={this.props.getAdminData}
                        disabled={!!this.props.disableAdminMode} />}
                {refresh && (
                    <RbButton
                        type={ButtonType.Secondary}
                        size={ButtonSize.Tiny}
                        label={'Refresh'}
                        style={{ minWidth: "3rem" }}
                        onClick={this.props.refresh}
                        disabled={!!this.props.disableAdminMode}
                    />
                )}
            </div>;
        }
        let element =
            <React.Fragment>
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm1 total-list-action-menu">
                            <RbLabel hasPadding={true}> Total: {this.props.items.length} </RbLabel>
                        </div>
                        <div className="ms-Grid-col ms-sm4">
                            <RbSearchField placeholder="Search..." onChange={(event) => this.props.searchText(event.currentTarget.value)} />
                        </div>
                        <div className="ms-Grid-col ms-sm7">
                            {menu}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        return element;
    }

    //Todo 
    exportToExcel = async () => {
        const items = [...this.props.items]
        const fileName = !!this.props.exportFileName && this.props.exportFileName !== "" && this.props.exportFileName || "New Record"
        if (!!items && items.length > 0) {
            const changeAuthorsFormatItems = items.map((item: any) => {
                if (!!item.authors && Array.isArray(item.authors)) {
                    return {
                        ...item,
                        authors: item.authors.join(';')
                    }
                }
                return item
            })
            await exportToExcel(changeAuthorsFormatItems, fileName)
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps, { showDialog, showToastMessage })(ListActionsMenu);